export enum VintageScoreAuthorEnum {
  PARKER = "parker",
  WINE_ADVOCATE = "wine_advocate",
  NEIL_MARTIN = "neil_martin",
  JANCIS_ROBINSON = "jancis_robinson",
  TIM_ATKIN = "tim_atkin",
  JAMES_SUCKLING = "james_suckling",
  JEFF_LEVE = "jeff_leve",
  DECANTER = "decanter",
  JANE_ANSON = "jane_anson",
  GUIA_PENIN = "guia_penin",
  WINE_SPECTATOR = "wine_spectator",
  WINE_ENTHUSIAST = "wine_enthusiast",
  FALSTAFF = "falstaff",
}
